// Статусы багажа (синхронизировано с BaggageStatus в HajjTravel.API/src/models/baggage.model.ts)
export const BAGGAGE_STATUS_LABELS: Record<string, string> = {
  registered: "Зарегистрирован",
  accepted: "Принят",
  in_transit: "В пути",
  arrived: "Прибыл",
  delivered: "Выдан",
  lost: "Утерян",
  damaged: "Повреждён",
  held: "Задержан",
};

export const BAGGAGE_STATUS_OPTIONS = Object.entries(BAGGAGE_STATUS_LABELS).map(
  ([id, name]) => ({ id, name }),
);

export const baggageStatusLabel = (status?: string) =>
  status ? BAGGAGE_STATUS_LABELS[status] ?? status : "";

// Цвет статуса для MUI Chip — единый корпоративный код для списка и детальной.
type StatusColor = "default" | "info" | "primary" | "success" | "warning" | "error";

export const BAGGAGE_STATUS_COLORS: Record<string, StatusColor> = {
  registered: "default",
  accepted: "info",
  in_transit: "primary",
  arrived: "info",
  delivered: "success",
  lost: "error",
  damaged: "error",
  held: "warning",
};

export const baggageStatusColor = (status?: string): StatusColor =>
  (status && BAGGAGE_STATUS_COLORS[status]) || "default";

// Типы мест багажа для формы
export const BAGGAGE_TYPE_OPTIONS = [
  { id: "Деревянная обрешетка", name: "Деревянная обрешетка" },
  { id: "Стрейт-пленка", name: "Стрейт-пленка" },
  { id: "Картонная коробка", name: "Картонная коробка" },
  { id: "Мешок", name: "Мешок" },
  { id: "unknown", name: "Без упаковки" },
];
